export default "__VITE_ASSET__vs$6hBK1__"